import type { CSSProperties } from 'react';

interface CRTOverlayProps {
  scanlineAlpha?: number;
}

const scanlineStyle: CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  pointerEvents: 'none',
  zIndex: 9999,
};

const vignetteStyle: CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  pointerEvents: 'none',
  zIndex: 9999,
  background: 'radial-gradient(ellipse at center, transparent 50%, rgba(0, 0, 0, 0.6) 100%)',
};

export function CRTOverlay({ scanlineAlpha = 0.08 }: CRTOverlayProps) {
  if (scanlineAlpha === 0) {
    return null;
  }

  const scanlineBackground = `repeating-linear-gradient(
    0deg,
    rgba(0, 0, 0, ${scanlineAlpha}),
    rgba(0, 0, 0, ${scanlineAlpha}) 1px,
    transparent 1px,
    transparent 2px
  )`;

  return (
    <>
      <div style={{ ...scanlineStyle, background: scanlineBackground }} />
      <div style={vignetteStyle} />
    </>
  );
}
